module.exports = __webpack_public_path__ + "static/media/loader.58b3d3f2.gif";